











































































import Vue from "vue";
import { mapState } from "vuex";
import { Anime, Seiyuu, Character } from "../store";
import { uniqBy } from "lodash";
import { getName, getTitle, getImage } from "@/utils/data-utils";

interface TableData {
  name: Seiyuu["name"];
  character: Character;
  role: string;
}
export default Vue.extend({
  name: "SeiyuuTable",

  data: () => ({
    search: "",
    showMenu: false as any,
    menuData: undefined as any
  }),

  methods: {
    fuzzySearch(value: any, search: string, item: any) {
      if (!value?.name) return false;
      return value.name.toLowerCase().includes(search?.toLowerCase() ?? "");
    },
    setMenu(event: MouseEvent, value: any) {
      this.menuData = false;
      this.$nextTick(() => {
        this.showMenu = true;
        this.menuData = {
          x: event.clientX,
          y: event.clientY,
          item: value.item
        };
      });
      event.preventDefault();
    },
    searchGoogle(what: string) {
      window.open(
        "https://www.google.com/search?q=" + encodeURIComponent(what)
      );
    }
  },
  computed: {
    ...mapState([
      "searchResult",
      "selectedSeiyuu",
      "recentAnime",
      "loadingResult"
    ]),
    seiyuuList() {
      return [
        "item.anime",
        ...(this.selectedSeiyuu as Seiyuu[]).map(s => "item." + getName(s))
      ];
    },
    tableHeader() {
      return [
        {
          text: "Anime",
          value: "anime",
          width: 250
        },
        {
          text: "Animes",
          value: "animes",
          divider: true,
          width: 50,
          align: "center"
        },
        ...(this.selectedSeiyuu as Seiyuu[]).map(s => ({
          text: getName(s),
          value: getName(s),
          width: 250
        }))
      ];
    },
    tableItems() {
      const animes: Seiyuu["anime"] = uniqBy(
        (this.selectedSeiyuu as Seiyuu[]).reduce(
          (acc, seiyuu) => [
            ...new Set([
              ...(seiyuu.anime ?? [])
                .map(e => JSON.parse(JSON.stringify(e ?? "")))
                .filter(e => e !== undefined),
              ...(acc ?? [])
            ])
          ],
          [] as Seiyuu["anime"]
        ),
        e => getTitle(e)
      );
      const rows = animes.map(({ id, ...rest }) => {
        const seiyuus: {
          name: Seiyuu["name"];
          character: Character;
        }[] = (this.selectedSeiyuu as Seiyuu[])
          .map(e => {
            const c = e.anime?.find(c => c.id === id);
            return (
              c !== undefined && {
                name: e.name,
                character: c.character[0]
              }
            );
          })
          .filter((e): e is TableData => e !== false);
        return {
          id,
          seiyuus,
          ...rest
        };
      });
      console.log(rows);
      const res = rows.map(r => {
        const res: {
          [key: string]: string | { name: string; image?: string; id?: string };
        } = {
          anime: {
            name: getTitle(r),
            image: r.image ?? "",
            id: r.id
          },
          animes: String(r.seiyuus.length)
        };
        r.seiyuus.forEach(a => {
          res[getName(a)] = {
            name: getName(a.character),
            image: getImage(a.character)
          };
        });
        return res;
      });
      console.log(res);
      return res;
    }
  }
});
